import { Component } from "@angular/core";

@Component({
  selector: "app-course-registration",
  templateUrl: "./course-registration.component.html",
  styleUrls: ["./course-registration.component.css"],
})
export class CourseRegistrationComponent {
  courses = [
    {
      ref_no: "SOCI001-00",
      title: "Legal Case Studies in Engineering Practice",
      description:
        "It is designed to provide engineers with a comprehensive understanding of the legal landscape that governs engineering practices. Engineering projects often involve complex legal issues, so professionals must be well-versed in relevant legal principles, case law, and regulatory frameworks. This course will equip participants with the knowledge and skills to navigate legal challenges effectively and make informed decisions that align with engineering standards and legal requirements. A legal case on a recent elevator accident will be shared to illustrate the application.",
      formLink:
        "https://docs.google.com/forms/d/e/1FAIpQLSfskUJtpzsLDnXUHjhdOFHfwA7DCd87HeFNHzMhEc3hI5QHUQ/viewform?usp=header",
      showSessions: false,
      sessions: [
        {
          month: "July",
          date: "13 July 2025 (Sun)",
          time: "2:00 pm-6:00 pm",
          code: "CPD0725/2025",
          fee: "$3000",
        },
        {
          month: "September",
          date: "14 September 2025 (Sun)",
          time: "2:00 pm-6:00 pm",
          code: "CPD0924/2025",
          fee: "$3000",
        },
        {
          month: "November",
          date: "9 November 2025 (Sun)",
          time: "2:00 pm-6:00 pm",
          code: "CPD1129/2025",
          fee: "$3000",
        },
      ],
    },
    {
      ref_no: "SOCI002-00",
      title: "Machine Learning in Engineering Practice",
      description:
        "Machine learning empowers engineers by enhancing decision-making capabilities, automating repetitive tasks, enabling predictive maintenance, optimizing design processes, improving quality control, reducing costs, enhancing customer experience, and providing scalability. These benefits enable engineers to tackle complex challenges more effectively and innovate. Engineering examples of data acquisition by measurements and simulations and subsequent machine learning are illustrated step-by-step in detail.",
      formLink:
        "https://docs.google.com/forms/d/e/1FAIpQLSdaRUwzdEAnEizXlTlzCLkwZBYhg-oW_jEpWzDpnt_ENe3ngQ/viewform?usp=header",
      showSessions: false,
      sessions: [
        {
          month: "August",
          date: "10 August 2025 (Sun)",
          time: "2:00 pm-6:00 pm",
          code: "CPD0828/2025",
          fee: "$3000",
        },
        {
          month: "October",
          date: "12 October 2025 (Sun)",
          time: "2:00 pm-6:00 pm",
          code: "CPD1026/2025",
          fee: "$3000",
        },
        {
          month: "December",
          date: "14 December 2025 (Sun)",
          time: "2:00 pm-6:00 pm",
          code: "CPD1225/2025",
          fee: "$3000",
        },
      ],
    },
  ];

  toggleSessions(course: any) {
    course.showSessions = !course.showSessions;
  }
}
